import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import communityInfoFragment from '../../fragments/community/communityInfo';

import communityMetaDataFragment from '../../fragments/community/communityMetaData';

export const searchMyCommunitiesQuery = gql`
  query searchMyCommunities(
    $queryString: String
    $type: SearchType!
    $userId: String
  ) {
    search(queryString: $queryString, type: $type, userId: $userId) {
      searchResultsConnection {
        edges {
          node {
            ... on Community {
              ...communityInfo
              ...communityMetaData
            }
          }
        }
      }
    }
  }
  ${communityInfoFragment}
  ${communityMetaDataFragment}
`;

const searchMyCommunitiesOptions = {
  options: ({ queryString, userId }) => ({
    variables: {
      queryString,
      type: 'MY_COMMUNITIES',
      userId,
    },
    fetchPolicy: 'network-only',
  }),
};

export default graphql(searchMyCommunitiesQuery, searchMyCommunitiesOptions);
